const SET_SCREEN_VIEWPORT = 'SET_DISPLAY_WIDTH';
const SET_LIST_RELATION = 'SET_LIST_RELATION';
const IS_INTERNET_CONNECTED = 'IS_INTERNET_CONNECTED';

const setScreenViewport = (payload) => ({
  type: SET_SCREEN_VIEWPORT,
  payload,
});

const setListRelation = (payload) => ({
  type: SET_LIST_RELATION,
  payload,
});

const isInternetConnected = (payload) => ({
  type: IS_INTERNET_CONNECTED,
  payload,
});

export {
  SET_SCREEN_VIEWPORT,
  setScreenViewport,
  SET_LIST_RELATION,
  setListRelation,
  IS_INTERNET_CONNECTED,
  isInternetConnected,
};
